import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { inject, onMounted, reactive, ref } from "vue";
import { OrderItemServiceSymbol, ProductServiceSymbol, TaxRateServiceSymbol } from "@/InjectionSymbols";
import ProductMetaContainer from "@/components/ProductMetaContainer.vue";
import { CartItemDto } from "@/dto/CartItemDto";
import CustomOrderItem from "@/model/CustomOrderItem";
import KrumosCalendar from "@/components/KrumosCalendar.vue";
import { validationRules } from "@/ValidationRules";
import { Formatter } from "@/util/Formatter";
var ItemType;
(function (ItemType) {
    ItemType[ItemType["NOT_SET"] = 0] = "NOT_SET";
    ItemType[ItemType["STANDARD"] = 1] = "STANDARD";
    ItemType[ItemType["CUSTOM"] = 2] = "CUSTOM";
})(ItemType || (ItemType = {}));
export default /*@__PURE__*/ _defineComponent({
    __name: 'AddOrderItemPanel',
    props: {
        orderId: { type: Number, required: true },
    },
    emits: ['orderUpdated'],
    setup(__props, { emit: __emit }) {
        const productService = inject(ProductServiceSymbol);
        const taxRateService = inject(TaxRateServiceSymbol);
        const orderItemService = inject(OrderItemServiceSymbol);
        const productsWrapper = reactive({ value: [] });
        let selectedProduct = ref(null);
        const form = ref(null);
        const taxrates = reactive([]);
        let itemType = ref(ItemType.NOT_SET);
        let customItem = reactive(new CustomOrderItem());
        let dialog = ref(false);
        const props = __props;
        const emit = __emit;
        onMounted(() => {
            productService?.loadAllProducts().then(response => productsWrapper.value = response);
            taxRateService.loadAllTaxRates().then(response => {
                taxrates.length = 0;
                response.forEach(value => taxrates.push(value));
            });
        });
        function onDateSelected(dateFrom, dateTo) {
            customItem.dateFrom = dateFrom;
            customItem.dateTo = dateTo;
        }
        function addOrderItem(cartItem) {
            let cartItemDto = new CartItemDto(cartItem);
            orderItemService.addOrderItem(props.orderId, cartItemDto)
                .then((response) => {
                dialog.value = false;
                selectedProduct.value = null;
                itemType.value = ItemType.NOT_SET;
                emit('orderUpdated', response.data);
            });
        }
        function addCustomOrderItem() {
            form.value.validate().then((result) => {
                if (result.valid) {
                    orderItemService.addCustomOrderItem(props.orderId, customItem)
                        .then((response) => {
                        dialog.value = false;
                        selectedProduct.value = null;
                        itemType.value = ItemType.NOT_SET;
                        emit('orderUpdated', response.data);
                    });
                }
            });
        }
        function onAbort() {
            selectedProduct.value = null;
            itemType.value = ItemType.NOT_SET;
        }
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_autocomplete = _resolveComponent("v-autocomplete");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_select = _resolveComponent("v-select");
            const _component_v_form = _resolveComponent("v-form");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_dialog = _resolveComponent("v-dialog");
            return (_openBlock(), _createBlock(_component_v_dialog, {
                width: "unset",
                modelValue: _unref(dialog),
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => (_isRef(dialog) ? (dialog).value = $event : dialog = $event)),
                "onClick:outside": onAbort
            }, {
                activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_btn, _mergeProps(props, { "data-cy": "add-product" }), {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                            _createTextVNode("Leistung Hinzufügen ")
                        ])),
                        _: 2
                    }, 1040)
                ]),
                default: _withCtx(() => [
                    _createVNode(_component_v_card, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_form, {
                                ref_key: "form",
                                ref: form
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_container, { class: "text-h5 text-start font-weight-bold" }, {
                                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                                            _createTextVNode("Leistung hinzufügen")
                                        ])),
                                        _: 1
                                    }),
                                    (!(_unref(itemType) === ItemType.CUSTOM))
                                        ? (_openBlock(), _createBlock(_component_v_container, {
                                            key: 0,
                                            class: "text-center"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_autocomplete, {
                                                    style: { "min-width": "400px" },
                                                    modelValue: _unref(selectedProduct),
                                                    "onUpdate:modelValue": [
                                                        _cache[0] || (_cache[0] = ($event) => (_isRef(selectedProduct) ? (selectedProduct).value = $event : selectedProduct = $event)),
                                                        _cache[1] || (_cache[1] = ($event) => (_isRef(itemType) //@ts-ignore
                                                            ? itemType.value = ItemType.STANDARD : itemType = ItemType.STANDARD))
                                                    ],
                                                    items: productsWrapper.value,
                                                    "item-title": "title",
                                                    label: "Leistung auswählen",
                                                    "return-object": "",
                                                    "hide-details": "",
                                                    variant: "outlined",
                                                    "data-cy": "select-product"
                                                }, null, 8, ["modelValue", "items"]),
                                                (_unref(itemType) === ItemType.NOT_SET)
                                                    ? (_openBlock(), _createBlock(_component_v_container, {
                                                        key: 0,
                                                        class: "font-weight-bold text-center"
                                                    }, {
                                                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                                                            _createTextVNode("oder")
                                                        ])),
                                                        _: 1
                                                    }))
                                                    : _createCommentVNode("", true),
                                                (_unref(itemType) === ItemType.NOT_SET)
                                                    ? (_openBlock(), _createBlock(_component_v_btn, {
                                                        key: 1,
                                                        onClick: _cache[2] || (_cache[2] = ($event) => (_isRef(itemType) //@ts-ignore
                                                            ? itemType.value = ItemType.CUSTOM : itemType = ItemType.CUSTOM)),
                                                        class: "w-100",
                                                        "data-cy": "create-custom-item"
                                                    }, {
                                                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                                                            _createTextVNode("Custom Item erstellen ")
                                                        ])),
                                                        _: 1
                                                    }))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true),
                                    (_unref(selectedProduct))
                                        ? (_openBlock(), _createBlock(_component_v_container, {
                                            key: 1,
                                            class: "pt-0",
                                            style: { "min-width": "600px" }
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(ProductMetaContainer, {
                                                    product: _unref(selectedProduct),
                                                    onButtonClick: addOrderItem
                                                }, {
                                                    button: _withCtx(() => _cache[11] || (_cache[11] = [
                                                        _createTextVNode("Add to Order")
                                                    ])),
                                                    _: 1
                                                }, 8, ["product"])
                                            ]),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true),
                                    (_unref(itemType) === ItemType.CUSTOM)
                                        ? (_openBlock(), _createBlock(_component_v_container, {
                                            key: 2,
                                            style: { "min-width": "600px" }
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(KrumosCalendar, {
                                                    class: "mb-4 w-auto d-block",
                                                    "init-date-from": _unref(customItem).dateFrom,
                                                    "init-date-to": _unref(customItem).dateTo,
                                                    onDateSelected: onDateSelected
                                                }, null, 8, ["init-date-from", "init-date-to"]),
                                                _createVNode(_component_v_text_field, {
                                                    modelValue: _unref(customItem).productTitle,
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(customItem).productTitle) = $event)),
                                                    rules: [_unref(validationRules).required],
                                                    label: "Beschreibung",
                                                    variant: "outlined",
                                                    density: "compact",
                                                    "data-cy": "custom-description"
                                                }, null, 8, ["modelValue", "rules"]),
                                                _createVNode(_component_v_container, { class: "pa-0 ma-0 d-flex flex-wrap" }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_text_field, {
                                                            class: "pr-2",
                                                            density: "compact",
                                                            rules: [_unref(validationRules).required, _unref(validationRules).currency],
                                                            "model-value": _unref(customItem).grossPrice,
                                                            onInput: _cache[4] || (_cache[4] = ($event) => (_unref(customItem).grossPrice = $event.target.value)),
                                                            label: "Preis (Brutto)",
                                                            variant: "outlined",
                                                            suffix: "€",
                                                            "data-cy": "custom-price"
                                                        }, null, 8, ["rules", "model-value"]),
                                                        _createVNode(_component_v_select, {
                                                            class: "pl-2",
                                                            modelValue: _unref(customItem).taxRateId,
                                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(customItem).taxRateId) = $event)),
                                                            rules: [_unref(validationRules).required],
                                                            items: taxrates,
                                                            "item-title": "rate",
                                                            "item-value": "id",
                                                            label: "Mehrwertsteuer",
                                                            "item-props": (item) => ({ title: _unref(Formatter).decimalToPercent(item.rate) }),
                                                            variant: "outlined",
                                                            density: "compact",
                                                            "data-cy": "custom-item-tax-rate"
                                                        }, null, 8, ["modelValue", "rules", "items", "item-props"])
                                                    ]),
                                                    _: 1
                                                }),
                                                _createVNode(_component_v_btn, {
                                                    onClick: addCustomOrderItem,
                                                    class: "w-100",
                                                    "data-cy": "add-custom-item"
                                                }, {
                                                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                                                        _createTextVNode("Item hinzufügen")
                                                    ])),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            }, 512)
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
